"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeadlineChapterProperty = exports.headlineChapterPropertyDefinition = void 0;
exports.headlineChapterPropertyDefinition = {
    view: { label: 'Chapter' },
    constraints: [],
    default: false,
    type: 'boolean',
    multiple: false,
    name: 'headline-chapter',
};
const isHeadlineChapterProperty = (prop) => {
    return prop.name === exports.headlineChapterPropertyDefinition.name;
};
exports.isHeadlineChapterProperty = isHeadlineChapterProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGxpbmUtY2hhcHRlci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2hlYWRsaW5lLWNoYXB0ZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFO0lBQzFCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsT0FBTyxFQUFFLEtBQUs7SUFDZCxJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGtCQUFrQjtDQUNPLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==